import { createContext, useContext } from "react";

const TabsContext = createContext(null);

export function useTabsContext(componentName) {
  const ctx = useContext(TabsContext);
  if (!ctx) {
    throw new Error(
      `<${componentName}> must be rendered inside a <Tabs> component.`,
    );
  }
  return ctx;
}

export default TabsContext